import { configure } from 'mobx';

export const initializeMobX = (() => {
  let initialized = false;
  return () => {
    if (!initialized) {
      configure({
        enforceActions: 'always',
        computedRequiresReaction: true,
        observableRequiresReaction: true,
        reactionRequiresObservable: true,
      });
      initialized = true;
    }
  };
})();
